import React from "react";
import Typography from "@material-ui/core/Typography";
const FAQs = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Frequently Asked Questions
      </Typography>
      <Typography paragraph variant="h5">
        Stuck on a particular problem? Check some of these common gotchas first
        in the FAQ.
      </Typography>
      <Typography paragraph variant="body1">
        If you still can't find what you're looking for, you can refer to our
        support page.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How long the login session is active?
      </Typography>
      <Typography paragraph variant="body1">
        The login will be expired after 2 hours of usage to prevent the risk of
        security issues. Once expired, the user is able to log in again. The
        user is also able to set the session for a longer time by clicking the
        "Keep me sign in" feature during login but we do not recommend it due to
        the risk of being hijacked by someone when the user forgot to log out of
        the session when they finish the job.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How to change the platform background?
      </Typography>
      <Typography paragraph variant="body1">
        There are two options to change the platform theme. First, the user can
        change the Aside color to Light or Dark. Second, the user can change the
        background by selecting the provided Invifo Themes or Custom Themes
        which are uploaded by Administrator. The setting of both options is
        located on the left of the User Profile on the top-right of the screen.
      </Typography>
    </React.Fragment>
  );
};

export default FAQs;
